import { render, staticRenderFns } from "./CandidatesTasksPage.vue?vue&type=template&id=a3359f38&scoped=true&lang=pug"
import script from "./CandidatesTasksPage.vue?vue&type=script&lang=js"
export * from "./CandidatesTasksPage.vue?vue&type=script&lang=js"
import style0 from "./CandidatesTasksPage.vue?vue&type=style&index=0&id=a3359f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3359f38",
  null
  
)

export default component.exports